import { useDispatch, useSelector } from 'react-redux'
import EditItem from '../../../../shared/components/IconButtons/EditItem'
import CampoInputRadio from '../../../../shared/components/CampoInputComButton/CampoInputRadio/CampoInputRadio'
import { useEffect, useState } from 'react'
import { handleOcorrenciaChange } from '../../../../../store/reducers/ocorrenciaSlice'

const CampoInputFoiSeco = ({ onClick, editButton, disabled }) => {
    const [value, setValue] = useState("")
    const dispatch = useDispatch()
    
    const handleChange = (name, value) => {
        if(value === "Sim") dispatch(handleOcorrenciaChange({[name]: "1"}))
        if(value === "Não") dispatch(handleOcorrenciaChange({[name]: "0"}))
        setValue(value)
    }

    const { dry_dryer } = useSelector(state => state.ocorrenciaState)
    
    useEffect(() => {
        if(dry_dryer === "1") setValue("Sim") 
        if(dry_dryer === "0") setValue("Não") 
        if(dry_dryer === "") setValue()
    }, [dry_dryer])
    
    const handleClick = (e) => {
        e.preventDefault()
        onClick("dry_dryer")
    }

    return (
        <CampoInputRadio
            id="inputFoiSeco"
            titulo="Artigo foi secado em secadora?*"
            onChange={handleChange}
            name="dry_dryer"
            value={value}
            radioValores={["Sim", "Não"]}
            required={true}
            disabled={disabled} >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputRadio>
    )
}

export default CampoInputFoiSeco
